import { render, staticRenderFns } from "./HabitabilityCard.vue?vue&type=template&id=ab03e1cc"
import script from "./HabitabilityCard.vue?vue&type=script&lang=ts"
export * from "./HabitabilityCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports